import React, { useEffect } from 'react';

import { slk } from 'survey-core';

import { StylesManager, SurveyCreator } from 'survey-creator';
import 'survey-creator/survey-creator.css';

import * as widgets from 'surveyjs-widgets';

import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/themes/base/all.css';
import 'jquery-bar-rating';
import 'jquery-bar-rating/dist/themes/css-stars.css';
import 'jquery-bar-rating/dist/themes/fontawesome-stars.css';
import 'select2/dist/js/select2';
import 'select2/dist/css/select2.css';
import 'pretty-checkbox/dist/pretty-checkbox.css';

const SurveyKo = require('survey-creator/node_modules/survey-knockout');

SurveyKo.settings.panelMaximumPanelCount = 4500;

StylesManager.applyTheme('modern');

slk(process.env.REACT_APP_SURVEYJS_LICENSE_KEY || 'your-license-key-here');

widgets.prettycheckbox(SurveyKo);
widgets.select2(SurveyKo, $);
widgets.inputmask(SurveyKo);
widgets.jquerybarrating(SurveyKo, $);
widgets.jqueryuidatepicker(SurveyKo, $);
widgets.nouislider(SurveyKo);
widgets.select2tagbox(SurveyKo, $);
widgets.sortablejs(SurveyKo);
widgets.ckeditor(SurveyKo);
widgets.autocomplete(SurveyKo, $);
widgets.bootstrapslider(SurveyKo);

const options = {
  haveCommercialLicense: true,
};

const containerId = 'surveyCreatorContainer';

interface SurveyCreatorRenderComponentProps {
  model: any;
  onSave: (json: any, callback: () => void) => void;
}

const SurveyCreatorRenderComponent: React.FC<SurveyCreatorRenderComponentProps> = ({
  model,
  onSave,
}) => {
  useEffect(() => {
    const surveyCreator = new SurveyCreator(containerId, options);
    surveyCreator.JSON = model;
    surveyCreator.saveSurveyFunc = () => {
      onSave(surveyCreator.JSON, () => {});
    };
  }, [model, onSave]);

  return <div id={containerId} />;
};

export default SurveyCreatorRenderComponent;
